import {
  TimeState,
  decimalHoursToString,
  hoursStringToDecimal,
} from "lib/time";
import { useEffect, useState } from "react";

interface TimerCheckinProps {
  timeAt?: string | undefined;
  onTimeMins: Function;
}

function TimerCheckin(props: TimerCheckinProps) {
  const calculateTimeLeft = (): TimeState => {
    let create = new Date(props.timeAt ?? "");
    let now = new Date();
    let timeLeft: TimeState = {};
    let plus30Min = new Date(create.getTime() + 30 * 60000).toString();
    const diff = dateDiff(now.toString(), plus30Min);
    props.onTimeMins(diff);
    if ((diff.minutes ?? 0) < 0) {
      timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    } else {
      timeLeft = {
        days: diff.days,
        hours: diff.hours,
        minutes: diff.minutes,
        seconds: diff.seconds,
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState<TimeState>(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  function dateDiff(str1: string, str2: string): TimeState {
    var dStr1 = new Date(str1);
    var dStr2 = new Date(str2);
    var diff = dStr2.getTime() - dStr1.getTime();
    return isNaN(diff)
      ? {}
      : {
          diff: diff,
          ms: Math.floor(diff % 1000),
          seconds: Math.floor((diff / 1000) % 60),
          minutes: Math.floor((diff / 60000) % 60),
          hours: Math.floor((diff / 3600000) % 24),
          days: Math.floor(diff / 86400000),
        };
  }

  const sumHors = hoursStringToDecimal(
    `${timeLeft?.minutes?.format(0, 0)}:${timeLeft?.seconds?.format(0, 0)}`
  );

  return (
    <div className="btn text-left">
      <div className="btn-group">
        <div className="card card-ufa-category font-white border-ufa-grey">
          <div
            style={{
              float: "left",
              marginTop: 2,
              padding: 10,
            }}
          >
            <span>{decimalHoursToString(sumHors)} นาที</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TimerCheckin;
